import { put, takeLatest } from 'redux-saga/effects';
import {
    getUserDataAction,
    getUserDataSuccessAction,
    getUserDataErrorAction,
} from '../../store/shared/private-route.store';
import { ApiResponse } from '../../api/request';
import { meAPI } from "../../api/provider/auth/auth-provider";
import { userSetDataAction } from '../../store/user.store';
import { authenticatedCall } from '../../utils/authenticated-call';


function* getUserDataSaga(data: any) {
  let meResult: ApiResponse | null = null

  try {
    meResult = yield authenticatedCall(meAPI)
    yield put(userSetDataAction(meResult?.data.data))
    yield put(getUserDataSuccessAction())
  } catch (error: any) {
    yield put(getUserDataErrorAction(error.localizedMessage))
    return
  }
}


export function* privateRouteSagas() {
  yield takeLatest(getUserDataAction.type, getUserDataSaga);
}
